module.exports = __webpack_public_path__ + "static/media/exclamation-circle.c2611212.svg";